<template>
  <div>
    <a
      :href="`tel:${number}`"
      :class="className"
      class="text-primary text-lowercase text-decoration-none text-body-large"
    >
      <v-icon
        :icon="icon"
        :size="size"
      />
      {{ number ?? '' }}
    </a>
    <v-btn
      v-tooltip="t('actions.copy')"
      color="primary"
      :class="className"
      :size="size"
      variant="plain"
      @click="copyToClipboard()"
    >
      <v-icon
        icon="fas fa-copy"
        :size="size"
      />
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const props = withDefaults(defineProps<{
  number: string;
  icon?: string;
  size?: string;
  className?: string;
}>(), {
  icon: () => 'fas fa-mobile-screen',
  size: () => 'small',
  className: () => 'text-body-large',
});

const { t } = useI18n();
function copyToClipboard() {
  navigator.clipboard.writeText(props.number);
}
</script>
